export class AppleLoginModel {
  public code: string;
  public signupReason?: string;
}
